import { computed } from 'vue'
import subscriptionService from '@/services/subscription-service'
import urls from '@/lib/urls'

/**
 * Map configuration utilities, used across verticals, providers, viewers, and page components
 */

/**
 * Get the "3d" URL parameter value
 * @returns '1' if 3d is enabled, '0' if disabled, null if not set
 */
export const get3dParam = () => urls.get3dParam()

/**
 * Returns map max pitch
 * implemented with shouldDisable3d in WebmapMapViewerMapbox & viewer-init
 * @param disable3d
 */
export const getMaxPitch = (disable3d: boolean): number => {
  const maxPitch = disable3d ? 0 : 85
  return maxPitch
}

/**
 * Computed prop replacement configurations that support all verticals
 * can be separated later when we move to mono repo structure
 */

/**
 * Whether the user has an active paid subscription
 */
export const isPaidMember = computed<boolean>(() =>
  subscriptionService.hasActiveSubscription()
)

/**
 * Disable 3D map features
 * replaces disable3D prop used across all verticals
 */
export const shouldDisable3d = computed(() => {
  return !isPaidMember.value
})

/**
 * Disable drag-to-rotate interaction on the map
 * replaces `disableDragRotate` prop used across all verticals
 */
export const disableDragRotate = computed(() => {
  return false
})

/**
 * Initial pitch angle for map initialization & setting initial map camera
 * - Fish: undefined
 */
export const initialPitch = computed<number | undefined>(() => {
  return undefined
})
